module.exports = __webpack_public_path__ + "static/day1-6c0535c6fb89906f085125fa2f8f1722.mp4";